// @ngInject
function CustomerOrderApiService($q, $window, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'customerorders';

    return {
        getAll: getAll,
        getById: ResourcesService.apiFactory.get(endpoint),
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        cancelById: ResourcesService.apiFactory.delete(endpoint),
        getDeliveryNotePdf: getDeliveryNotePdf
    };

    function getAll(page, searchTerm, pageSize) {
        var deferred = $q.defer();
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (searchTerm && searchTerm.orderTypes && searchTerm.orderTypes.length > 0) {
            params.orderTypes = searchTerm.orderTypes;
        }

        if (searchTerm && searchTerm.selectedFromLocation && searchTerm.selectedFromLocation.id !== undefined) {
            params.fromLocation = searchTerm.selectedFromLocation.id;
        }

        if (searchTerm && !_.isEmpty(searchTerm.term)) {
            params.searchTerm = searchTerm.term;
        }

        if (searchTerm && searchTerm.onlyOrderNumber !== undefined) {
            params.onlyOrderNumber = searchTerm.onlyOrderNumber;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint, {params: params}).then(function(response) {
            deferred.resolve(response.data);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getDeliveryNotePdf(orderId) 
    {
        var deferred = $q.defer();

        var request = {};

        DSHttpAdapter.POST(DS.defaults.basePath + 'customerorders/' + orderId + '/deliverynote', request, { responseType: 'arraybuffer' }).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('customerorders.api', [])
    .factory('CustomerOrderApiService', CustomerOrderApiService);
